module.exports = __webpack_public_path__ + "static/media/toshiba-logo.9846b66b.png";